// GA4 / GTM-compatible event tracking via window.dataLayer (+ PostHog mirror).
// Event names are lowercase snake_case. Callers are responsible for firing once
// per user action to avoid duplicate events.
export const track = (event, props = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...props });
  } catch (_) {
    /* analytics is best-effort */
  }
  try {
    window.posthog?.capture?.(event, props);
  } catch (_) {
    /* best-effort */
  }
};
